// extracted by mini-css-extract-plugin
module.exports = {"annal":"Search_annal__2Hqxc","text":"Search_text__2fV3W","fjdsioj2":"Search_fjdsioj2__2v7VN","content":"Search_content__3_O0U"};